var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "flex flex-col mb-4" },
    [
      _c(
        "div",
        { staticClass: "flex items-center" },
        [
          _c("BaseIcon", {
            staticClass: "w-4 h-4 mr-2",
            class: _vm.iconClass,
            attrs: { name: _vm.icon }
          }),
          _c(
            "span",
            { staticClass: "mr-2 text-gray-700" },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      _c(
        "BaseLink",
        {
          staticClass: "ml-6 text-sm self-start",
          on: {
            click: function($event) {
              return _vm.$emit("inspect")
            }
          }
        },
        [_vm._v(" view details ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }